const Cancel_Icon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="18" height="18" rx="9" fill="#A5DACB" fill-opacity="0.5" />
      <path
        d="M12.675 5.33076C12.4475 5.10326 12.08 5.10326 11.8525 5.33076L9.00004 8.17742L6.14754 5.32492C5.92004 5.09742 5.55254 5.09742 5.32504 5.32492C5.09754 5.55242 5.09754 5.91992 5.32504 6.14742L8.17754 8.99992L5.32504 11.8524C5.09754 12.0799 5.09754 12.4474 5.32504 12.6749C5.55254 12.9024 5.92004 12.9024 6.14754 12.6749L9.00004 9.82242L11.8525 12.6749C12.08 12.9024 12.4475 12.9024 12.675 12.6749C12.9025 12.4474 12.9025 12.0799 12.675 11.8524L9.82254 8.99992L12.675 6.14742C12.8967 5.92576 12.8967 5.55242 12.675 5.33076Z"
        fill="#1FA37C"
      />
    </svg>
  );
};

export default Cancel_Icon;
